import { Component, Host, Prop, h } from '@stencil/core';
import { ProductData } from '../order-overview-component/order-overview-component';





@Component({
  tag: 'shopping-cart-view',
  styleUrl: 'shopping-cart-view.scss',
  shadow: true,
})
export class ShoppingCartView {
  @Prop() productData: ProductData[] = [];
  @Prop() showButton: boolean = false;

  calcSum() {
    return this.productData.reduce((sum, item) => sum + item.price
      , 0);
  }

  private formatPrice(price: number): string {
    return Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price === 0 ? price : price / 100);
  }


  render() {
    return (
      <Host>
        {this.productData.map(item => {
          return (<div class="item">
            <div class="name">{item.name}</div>
            <div class="price">{this.formatPrice(item.price)}</div>
          </div>
          );
        })}
        <div class="total">
          <div class="total-text">
            Gesamt
          </div>
          <div class="total-price">
            {this.formatPrice(this.calcSum())}
          </div>
        </div>
        <slot name="button"></slot>
      </Host>
    );
  }
}
